<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            placeholder="Selecione Profissional..."
                            icon="fas fa-user-md fa-fw" 
                            type="select" 
                            optionsMode="aql"
                            service="medicos.index"
                            optionsName="medicos-cadastro"
                            :optionsParm="{ ativos: true }"
                            v-model="medico" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            placeholder="Não Repassados"
                            icon="fas fa-filter fa-fw"
                            type="select" 
                            optionsMode="json"
                            :optionsList="[
                                { id: 'S', search: 'Repassados' },
                                { id: 'T', search: 'Todos' },
                            ]"
                            optionsData="id"
                            v-model="filtros.repassados" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12">
                        <az-input
                            type="text"
                            icon="fa fa-search fa-fw"
                            placeholder="Pesquisar..."
                            v-model="search" />
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && dados && dados.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state :msg="!medico ? 'Selecione o Profissional' : 'Nenhum atendimento localizado'" icon="fas fa-search" v-if="!lista || !lista.length" />

        <template v-if="false">
            <div class="row" v-for="(marcacao, imx) in lista" :key="imx">
                <div class="col col-12 col-md-1">
                    #{{ marcacao.id_atendimento }}
                </div>
                <div class="col col-12 col-md-3">
                    <div>{{ marcacao.paciente.st_nome }}</div>
                    <div class="text-muted">{{ marcacao.plano.search }}</div>
                </div>
                <div class="col col-12 col-md-8">
                    <div class="row">
                        <div class="col">
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <table class="table table-responsive-md bg-white table-hover small" v-if="lista && lista.length">
            <thead>
                <tr>
                    <th width="10%">Data</th>
                    <th width="25%">Paciente</th>
                    <th width="28%">Procedimento</th>
                    <th width="19%">Regra</th>
                    <th width="8%" class="text-right">Valor</th>
                    <th width="8%" class="text-right">Rateio</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(marcacao, imx) in lista" :key="imx">
                    <td width="10%">
                        <div>{{ $util.getFormatDate(marcacao.dt_inicio) }}</div>
                        <div class="text-muted">#{{ marcacao.id_atendimento }}</div>
                    </td>
                    <td width="25%">
                        <div>{{ marcacao.paciente.st_nome }}</div>
                        <div class="text-muted">{{ marcacao.plano.search }}</div>
                    </td>
                    <td width="70%" colspan="4">
                        <table class="table table-borderless table-sm mb-0">
                            <tr v-for="(atp, iax) in marcacao.atendimento.atendimento_procedimentos" :key="iax">
                                <td width="40%">
                                    {{ atp.procedimento.search }}
                                    <span class="badge badge-secondary" v-if="atp.in_quantidade > 1">
                                        x{{ atp.in_quantidade }}
                                    </span>
                                    <div class="text-muted" v-if="!iax">{{ marcacao.medico.search }}</div>
                                    <div v-if="atp.item_repasses.length">
                                        <i class="fas fa-hand-holding-usd mr-2"></i>
                                        <span v-for="(rep, irx) in atp.item_repasses" :key="irx">
                                            <i class="fa fa-caret-right mx-2" aria-hidden="true" v-if="irx"></i>
                                            <span class="badge badge-secondary" v-if="rep.medico_repasse" title="Repasse">
                                                #{{ rep.medico_repasse.id_repasse }} / M{{ rep.medico_repasse.id_medico }}
                                            </span>
                                            <span class="badge badge-secondary" v-else title="MR">
                                                MR{{ rep.id_medico_repasse }}
                                            </span>
                                        </span>
                                    </div>
                                </td>
                                <td width="26%">
                                    <a href="#" class="card-link mr-2" @click.prevent="recalcular_rateio(atp)" v-if="!atp.item_repasses || !atp.item_repasses.length">
                                        <i class="fas fa-sync-alt"></i>
                                    </a>
                                    <span class="badge badge-danger" v-if="!atp.id_rateio_medico">Sem Rateio</span>
                                    <a href="#" @click.prevent="ver_criterio(atp.id_rateio_medico)" class="card-link mx-0" v-else>
                                        #{{ atp.id_rateio_medico }}
                                        <small v-if="atp.rateio_medico && atp.rateio_medico.st_titulo">
                                            {{ atp.rateio_medico.st_titulo }}
                                        </small>
                                    </a>                                   
                                    
                                </td>
                                <td width="12%" class="text-right">
                                    {{ $util.formatMoeda(atp.valor_base_repasse) }}
                                </td>
                                <td width="12%" class="text-right">{{ $util.formatMoeda(atp.valor_rateio) }}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="6">
                        <az-submit @click="recalcular_rateios()">
                            <i class="fas fa-sync-alt mr-2"></i>
                            Recalcular Rateios
                        </az-submit>
                    </td>
                </tr>
            </tfoot>
        </table>

        <pre v-if="false">{{ dados }}</pre>

        <edicao-rateio-medico ref="cadrateio" :viewonly="true" />

    </div>

</template>

<script>
import _ from 'lodash';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import EdicaoRateioMedico from '../../cadastros/shared/EdicaoRateioMedico.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';

export default {
    data() { 
        return { 
            inicio: this.$util.hoje(),
            fim: this.$util.hoje(),
            medico: "", 
            search: "",
            dados: [], 
            filtros: { 
                inicio: "",
                fim: "", 
                periodo: "h", 
                mes: "", 
                repassados: "", 
            },
        }
    },

    components: { 
        AzInput,
        AzEmptyState,
        AzSubmit, 
        AzPeriodo, 
        EdicaoRateioMedico, 
    },

    computed: { 
        lista: function () { 
            if ( !this.dados )
                return [];

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados.filter(item => { 
                    return ( !this.search || this.search.substr(0,1) == '#' || reg.test(JSON.stringify(item)) );
                });
        },
    },

    methods: { 
        recalcular_rateio (atp) {
            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'recalcular_rateio',
                dados: { 
                    id_atendimento_procedimento: atp.id_atendimento_procedimento,
                },
                toast: true,
                callback: res => { 
                    if ( res && res.id_rateio_medico == atp.id_rateio_medico ) { 
                        //
                    } else { 
                        this.load();
                    }
                }
            });
        },

        recalcular_rateios () { 
            let items = _.flatMap(this.lista, (item) => { 
                return item.atendimento.atendimento_procedimentos.filter(atp => !atp.item_repasses || !atp.item_repasses.length)
                    .map(atp => atp.id_atendimento_procedimento);
            });

            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'recalcular_rateios',
                dados: { 
                    lista: items,
                },
                toast: true,
                callback: () => { 
                    this.load();
                }
            });
        },

        load() { 
            this.$util.load(this, { 
                service: 'repasses',
                func: 'rateios',
                parms: { 
                    ...this.filtros, 
                    search: this.search, 
                    medico: this.medico ? this.medico.id_pessoa : null,
                },
            });
        },

        ver_criterio(id_rateio_medico) { 
            this.$refs.cadrateio.editar(id_rateio_medico);
        },
    },

    mounted() { 
        // this.load();

        this.$store.commit("setBreadcrumb", [
            { name: "Repasse", path: "" },
            { name: "Validação", path: "/repasse/validacao" }
        ]);
    }
}
</script>

